module.exports = __webpack_public_path__ + "img/withdraw.e15994a3.svg";